import EnumType from "@/app/shared/EnumType.js";

const values = {
  Round: 0,
  Slash: 1, 
  Bench: 2,
  BackslashRound: 3
};

export default EnumType.generate(values, "GradeControl.BlastType.");